import { Expose, Type } from "class-transformer"
import _ from "lodash"
import { CollectionRequest } from "../collection-request/collection-request"
import { FieldDescriptor, FieldTypeEnum } from "../field-descriptor"
import ActivityHistoryLog from "./activity-history-log"

class CollectionRequestExportLog extends ActivityHistoryLog {

  @Expose()
  @Type(() => CollectionRequest)
  public collectionRequest: CollectionRequest | null = null

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pickup_status",
    columnWidth: "60"
  })
  public get status() {
    return _.get(this.collectionRequest, "status")
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.collection_request.entry_date",
    hasTime: true,
    columnWidth: "90"
  })
  public get createdDate() {
    return this.collectionRequest.createdDate
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.parcel_number",
    columnWidth: "120"
  })
  public get parcelNumber() {
    return this.collectionRequest.parcelNumber
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.reference",
    columnWidth: "200"
  })
  public get reference() {
    return this.collectionRequest.reference
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.order_number",
    columnWidth: "200"

  })
  public get orderNumber() {
    return this.collectionRequest.orderNumber
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pickup_name",
    columnWidth: "65"
  })
  public get pickupName(): string | undefined {
    return this.collectionRequest.pickupName
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pickup_street",
    columnWidth: "65"
  })
  get pickupStreet(): string | undefined {
    return this.collectionRequest.pickupStreet
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pickup_city",
    columnWidth: "55"
  })
  get pickupCity(): string | undefined {
    return this.collectionRequest.pickupCity
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.info1",
    columnWidth: "55"
  })
  get info1(): string | undefined {
    return this.collectionRequest.info1
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.info2",
    columnWidth: "55"
  })
  get info2(): string | undefined {
    return this.collectionRequest.info2
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.service_code",
    columnWidth: "65"
  })
  public get serviceCode() {
    return this.collectionRequest.serviceCode
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pudo_id",
    columnWidth: "55"
  })
  public get pudoId(): string | undefined {
    return this.collectionRequest.pudoId
  }

  public static exportUrl: string | null = "collectionRequestExportLog/export/csv"

}

export default CollectionRequestExportLog
